import { Tooltip } from 'antd';
import React from 'react';
import TrendArrow from '../TrendArrow';

interface IProps {
    value?: number
    threshold: number
    strong?: boolean
    description: React.ReactNode
    className?: string
    vertical?: boolean
}

export const getDisplayValue = (value?: number) => typeof value === 'number'
    ? `${Math.round(value * 100) / 100}%`
    : '--';

const getValueConfig = (value: number, threshold: number) => {
    if (value < 0)
        return { colorClassName: 'text-[#E95D5D]', direction: 'up' as const };

    if (value === 0)
        return { colorClassName: 'text-[#E95D5D]', direction: 'flat' as const };

    if (value > threshold)
        return { colorClassName: 'text-[#72A64E]', direction: 'down' as const };

    return { colorClassName: 'text-[#677979]', direction: 'down' as const };
};

const ReductionValue: React.FC<IProps> = ({ value, threshold, strong, description, className, vertical }) => {
    const isAvailable = typeof value === 'number';
    const valueConfig = isAvailable ? getValueConfig(value, threshold) : null;

    return <span className={[
            'flex items-center whitespace-nowrap',
            strong ? (vertical ? 'font-[400]' : 'font-[600]') : '',
            valueConfig?.colorClassName || 'text-comment',
            className || ''
        ].join(' ')}>
        <Tooltip title={description}>
            <span className='inline-flex w-fit items-center whitespace-nowrap'>
                {getDisplayValue(value)}
            </span>
        </Tooltip>
        {valueConfig && <TrendArrow direction={valueConfig.direction} vertical={vertical} />}
    </span>;
};

export default ReductionValue;
